export function isPhoneNumber(input) {
  return !input || input === '' || /^\+[1-9]\d{6,14}$/.test(input)
}
